import React from 'react';
import Filters from '../../../components/Filter';
import FilterInput from '../../../components/Filter/components/FilterInput';
import { translate } from '../../../services/translate';
import { NavigationProp, RouteProp, useNavigation } from '@react-navigation/native';
import { CamerasParamList } from '../../../typings/Params';

interface Props {
    filters: CamerasParamList['DownloadTags'];
    setFilters: React.Dispatch<React.SetStateAction<CamerasParamList['DownloadTags']>>;
    textFilter: string;
    setTextFilter: React.Dispatch<React.SetStateAction<string>>;
}

function Filter({ filters, setFilters, textFilter, setTextFilter }: Props) {
    const navigation = useNavigation<NavigationProp<RouteProp<CamerasParamList, 'DownloadTags'>>>();

    const handleCleanFilter = () => {
        setTextFilter('');
    };

    const handleFilter = () => {
        navigation.setParams({
            ...filters,
            page: 1,
            textFilter: textFilter !== '' ? textFilter : undefined,
        });

        setFilters({
            ...filters,
            page: 0,
            textFilter: textFilter !== '' ? textFilter : undefined,
        });
    };

    return (
        <Filters onCleanFilters={handleCleanFilter} onFilters={handleFilter}>
            <FilterInput
                label={translate('typeToSearch')}
                value={textFilter}
                placeholder={translate('typeToSearch')}
                onChange={setTextFilter}
            />
        </Filters>
    );
}


export default Filter;
